// ─── Memorial Hall, mounted ──────────────────────────────────────────────────
//
// Two things wrap the app, and both are here rather than inside `App` on
// purpose: a boundary that lives inside the tree it is meant to catch is a
// boundary that goes down with it.
//
// ── Why this exists (2026-09-25) ────────────────────────────────────────────
//
// This app had NO error handling at all — no boundary, no crash reporting —
// while Farndale has both. On 2026-09-24 it went black-screen on Members and
// Proposals during a live demo to a business contact, and there was nothing
// anywhere to diagnose it from. The likeliest explanation is a stale bundle
// against a restarted server during that night's rotation loop, and it stays
// "likeliest" precisely because nothing recorded it.
//
// Both pieces are `@nulife/app-ui`'s, adapted from Farndale's own rather than
// invented here — see `ErrorBoundary.tsx` for what changed and why.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary, installCrashReporting } from "@nulife/app-ui";
import { App } from "./App.js";

// Before anything renders: an exception thrown while the first paint is still
// happening is one of the failures most worth catching, and a listener
// registered afterwards would miss it.
installCrashReporting();

const root = document.getElementById("root");
if (!root) throw new Error("No #root element — index.html and this entry disagree.");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary appName="memorial-hall">
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
